export default{
    msg:'',
    editar:{},
    lista:'',
    id:'',
    trabalhador:'',
}